import React from "react";
import SwaggerUI from "swagger-ui-react";
import { Typography } from "@mui/material";
import SwaggerWrapper from "../../components/SwaggerWrapper";

const Routing = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Routing API
      </Typography>
      <Typography variant="body2">
        The Routing API is part of the GraphHopper Directions API. Routing is the process of finding
        the best path connecting two or more points, where the meaning of depends on the vehicle
        profile and use case.
      </Typography>
      <SwaggerWrapper>
        <SwaggerUI
          url="/swagger/routing.json"
          docExpansion="full"
          showExtensions
          defaultModelsExpandDepth={3}
        />
      </SwaggerWrapper>
    </>
  );
};

export default Routing;
